<template>
  <a-card :bordered="false">
    <a-tabs defaultActiveKey="1" >
      <!-- 排课结果查询 -->
      <a-tab-pane key="1" tab="补考规则设置">
        <RuleSetting />
      </a-tab-pane>
      
      <!-- 跨校区检测 -->
      <a-tab-pane key="2" tab="批量设置可补考课程">
        <CourseBatch />
      </a-tab-pane>
      
      <!-- 学时统计 -->
      <a-tab-pane key="3" tab="补考申请" >
        <StudentApply/>
      </a-tab-pane>
      
      <!-- 班级课表分析 -->
      <a-tab-pane key="4" tab="补考任务">
        <TaskList />
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
import RuleSetting from './modules/RuleSetting'
import CourseBatch from './modules/CourseBatch'
import StudentApply from './modules/StudentApply'
import TaskList from './modules/TaskList'

export default {
  components: {
    RuleSetting,
    CourseBatch,
    StudentApply,
    TaskList
  }
}
</script>